import type { BankAccount } from '../../BankAccounts/Types/bankAccountTypes';

export interface InvoiceBankAccountLookup {
  id: number | null;
  accountNumber: string;
  iban: string;
  bankName?: string;
  name?: string;
  currency?: string;
  companyId?: number;
  isDefault?: boolean;
}

const normalizeValue = (value: string | undefined | null): string => value?.trim() ?? '';

const toNumber = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  return undefined;
};

export const mapBankAccountToInvoiceLookup = (
  bankAccount: BankAccount | undefined | null
): InvoiceBankAccountLookup | undefined => {
  if (!bankAccount) {
    return undefined;
  }

  const accountNumber = normalizeValue((bankAccount as any).accountNumber);
  const iban = normalizeValue((bankAccount as any).iban) || accountNumber;
  const bankName = normalizeValue((bankAccount as any).bankName) || undefined;
  const name =
    normalizeValue((bankAccount as any).name) ||
    normalizeValue((bankAccount as any).description) ||
    undefined;

  return {
    id: toNumber((bankAccount as any).id) ?? null,
    accountNumber,
    iban,
    bankName,
    name,
    currency: normalizeValue((bankAccount as any).currency) || undefined,
    companyId: toNumber((bankAccount as any).companyId),
    isDefault:
      typeof (bankAccount as any).isDefault === 'boolean'
        ? (bankAccount as any).isDefault
        : undefined,
  };
};
